/* eslint-disable @next/next/no-img-element */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faPhone } from "@fortawesome/pro-solid-svg-icons";
import { ComponentInfosLojaSchedulesInput } from "@/graphql/generated/graphql";
import { faHouseChimneyMedical } from "@fortawesome/pro-solid-svg-icons";
import styles from "./styles.module.scss";
import { useState } from "react";
import { formattedTime } from "@/utils/helpers";

export type SchedulesPaProps = {
  schedulesVet?: ComponentInfosLojaSchedulesInput;
  schedulesServices?: ComponentInfosLojaSchedulesInput;
  phoneServices?: string;
  onlineSchedule: boolean;
};

const SchedulesPa = ({
  schedulesVet,
  schedulesServices,
  phoneServices,
  onlineSchedule
}: SchedulesPaProps) => {
  const [activeTab, setActiveTab] = useState("tab-01");

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  return (
    <div className={styles.wrapper}>
      <div className="tabs-container tabs-horizontal">
        <div className="tabs tabs-pa-blue medium" role="tablist">
          {schedulesServices && (
            <button
              aria-controls="tab-01"
              aria-selected={activeTab === "tab-01"}
              className={`tab tab-left-icon ${activeTab === "tab-01" ? "active" : ""}`}
              id="tab-01-btn"
              onClick={() => handleTabClick("tab-01")}
              role="tab"
            >
              <div className="tab-icon">
                <img
                  src="/inst/img/icon/banho-e-tosa.svg"
                  alt="Banho e Tosa"
                  width={24}
                />
              </div>
              Banho e tosa
            </button>
          )}
          {schedulesVet && (
            <button
              aria-controls="tab-02"
              aria-selected={activeTab === "tab-02"}
              className={`tab tab-left-icon ${activeTab === "tab-02" ? "active" : ""}`}
              id="tab-02-btn"
              onClick={() => handleTabClick("tab-02")}
              role="tab"
            >
              <div className="tab-icon">
                <FontAwesomeIcon icon={faHouseChimneyMedical} />
              </div>
              Veterinário
            </button>
          )}
        </div>
      </div>

      {activeTab === "tab-01" && schedulesServices && (
        <div className={styles.schedule}>
          <div className={styles.icon}>
            <FontAwesomeIcon icon={faClock} fontSize={24} />
          </div>
          <div className={`${styles.content} body-text-md`}>
            <p>
              <span>Segunda à Sexta</span>
              <span>
                {formattedTime(schedulesServices.semanaAbertura)} às{" "}
                {formattedTime(schedulesServices.semanaFechamento)}
              </span>
            </p>
            <p>
              <span>Sábado</span>
              <span>
                {formattedTime(schedulesServices.sabadoAbertura)} às{" "}
                {formattedTime(schedulesServices.sabadoFechamento)}
              </span>
            </p>
            <p>
              <span>Domingo</span>
              <span>
                {formattedTime(schedulesServices.domingoAbertura)} às{" "}
                {formattedTime(schedulesServices.domingoFechamento)}
              </span>
            </p>
            <p>
              <span>Feriados</span>
              <span>
                {formattedTime(schedulesServices.feriadoAbertura)} às{" "}
                {formattedTime(schedulesServices.feriadoFechamento)}
              </span>
            </p>
          </div>
        </div>
      )}

      {activeTab === "tab-02" && schedulesVet && (
        <div className={styles.schedule}>
          <div className={styles.icon}>
            <FontAwesomeIcon icon={faClock} fontSize={24} />
          </div>
          <div className={`${styles.content} body-text-md`}>
            <p>
              <span>Segunda à Sexta</span>
              <span>
                {formattedTime(schedulesVet.semanaAbertura)} às{" "}
                {formattedTime(schedulesVet.semanaFechamento)}
              </span>
            </p>
            <p>
              <span>Sábado</span>
              <span>
                {formattedTime(schedulesVet.sabadoAbertura)} às{" "}
                {formattedTime(schedulesVet.sabadoFechamento)}
              </span>
            </p>
            <p>
              <span>Domingo</span>
              <span>
                {formattedTime(schedulesVet.domingoAbertura)} às{" "}
                {formattedTime(schedulesVet.domingoFechamento)}
              </span>
            </p>
            <p>
              <span>Feriados</span>
              <span>
                {formattedTime(schedulesVet.feriadoAbertura)} às{" "}
                {formattedTime(schedulesVet.feriadoFechamento)}
              </span>
            </p>
          </div>
        </div>
      )}

      {phoneServices && (
        <div className={styles.schedule}>
          <div className={styles.icon}>
            <a href={`tel:${phoneServices}`}>
              <FontAwesomeIcon icon={faPhone} fontSize={24} />
            </a>
          </div>
          <a className="body-text-md" href={`tel:${phoneServices}`}>
            {phoneServices}
          </a>
        </div>
      )}

      {onlineSchedule && (
        <a
          href="https://www.cobasi.com.br/servicos/agendamentos/bem-vindo/"
          target="_self"
          className={`btn btn-pa-blue ${styles.btn}`}
        >
          Agendar online
        </a>
      )}
    </div>
  );
};

export default SchedulesPa;
